export default __webpack_public_path__ + "static/media/02.7b36c041.jpg";